import React, { useState } from "react";
import { Plus, X } from "lucide-react";

export default function ChipGroup({
  options = [],
  value = [],
  onChange,
  onAddOption,
  testIdPrefix = "chip",
  allowAdd = true,
}) {
  const [adding, setAdding] = useState(false);
  const [newVal, setNewVal] = useState("");

  const toggle = (opt) => {
    const next = value.includes(opt) ? value.filter((v) => v !== opt) : [...value, opt];
    onChange?.(next);
  };

  const submitNew = () => {
    const v = newVal.trim();
    if (!v) {
      setAdding(false);
      return;
    }
    if (!options.includes(v)) onAddOption?.(v);
    if (!value.includes(v)) onChange?.([...value, v]);
    setNewVal("");
    setAdding(false);
  };

  return (
    <div className="flex flex-wrap gap-2">
      {options.map((opt) => {
        const selected = value.includes(opt);
        return (
          <button
            key={opt}
            type="button"
            className="rcw-chip"
            data-selected={selected}
            data-testid={`${testIdPrefix}-${opt.toLowerCase().replace(/[^a-z0-9]+/g, "-")}`}
            onClick={() => toggle(opt)}
          >
            {opt}
          </button>
        );
      })}
      {/* Extras already in value but not in options (custom-added) */}
      {value
        .filter((v) => !options.includes(v))
        .map((v) => (
          <button
            key={`custom-${v}`}
            type="button"
            className="rcw-chip"
            data-selected="true"
            onClick={() => toggle(v)}
            data-testid={`${testIdPrefix}-custom-${v.toLowerCase().replace(/[^a-z0-9]+/g, "-")}`}
          >
            {v}
          </button>
        ))}
      {allowAdd && !adding && (
        <button
          type="button"
          className="rcw-chip"
          onClick={() => setAdding(true)}
          data-testid={`${testIdPrefix}-add`}
        >
          <Plus className="h-3.5 w-3.5" /> Add
        </button>
      )}
      {adding && (
        <div className="inline-flex items-center gap-1 bg-white border border-gray-300 rounded-full pl-3 pr-1 py-1">
          <input
            autoFocus
            value={newVal}
            onChange={(e) => setNewVal(e.target.value)}
            onKeyDown={(e) => {
              if (e.key === "Enter") submitNew();
              if (e.key === "Escape") setAdding(false);
            }}
            placeholder="Add option…"
            className="text-sm outline-none bg-transparent w-32"
            data-testid={`${testIdPrefix}-add-input`}
          />
          <button
            type="button"
            onClick={submitNew}
            className="h-7 w-7 rounded-full bg-gray-900 text-white inline-flex items-center justify-center"
            data-testid={`${testIdPrefix}-add-confirm`}
          >
            <Plus className="h-3.5 w-3.5" />
          </button>
          <button
            type="button"
            onClick={() => setAdding(false)}
            className="h-7 w-7 rounded-full text-gray-500 inline-flex items-center justify-center"
          >
            <X className="h-3.5 w-3.5" />
          </button>
        </div>
      )}
    </div>
  );
}
